import Widget from "csi/form/Widget";
import reflection from "csi/reflection";
import declare from "dojo/_base/declare";

const RecipeDataSheetForm = declare(Widget, {

	/**
	 * @override
	 * Insert Subtype field if it hasn't been added to the FormDefinition
	 */
	_resolveView() {
		this.insertFieldIfNotExist(reflection.ATTR_SUBTYPE, 0);
		this.inherited(arguments);
	},

});

export = RecipeDataSheetForm;